import React from "react";
import COLORS from "./styleConstants";
export const horseAvatar = "/images/horse_avatar_01.svg";
export const clientAvatar = "/images/client_avatar_02.svg";
export const locationAvatar = "/images/staff_avatar_04.svg";
export const deleteImg = "/images/closeIcn-dark2.svg";
export const privateNoteImg = "/images/private_note_icon.jpg";
export const publicNoteImg = "/images/public_note_icon.jpg";
export const staffAvatar = "/images/staff_avatar_03.svg";
export const blueCheck = "/images/blueTickSml.svg";
export const downtArw = "/images/downtArw.svg";
export const logo = "/images/Equine_Office_logo.svg";
export const menuicon = "/images/menuicon.svg";
export const logoRed = "/images/horseonlypng191.png";
export const horseGreenBig = "/images/horseGreenBig.svg";
export const horseSleep = "/images/noHorses.svg";

export const Logo = () => {
  return <img style={{ width: 200, height: 100 }} src={logoRed} />;
};

export const MenuIcon = (props) => {
  console.log(props);
  return (
    <img
      src={menuicon}
      alt={"menu"}
      style={{
        background: COLORS.orange,
        width: 45,
        height: 35,
        zIndex: 100,
        cursor: "pointer",
        position: "absolute",
        left: props.showLeftNav ? -50 : 0,
        marginTop: 20,
        transform: props.showLeftNav ? "none" : "rotate(-180deg)",
        paddingLeft: props.showLeftNav ? 0 : 10,
      }}
    />
  );
};

export const HorseAvatar = (props) => {
  return (
    <img
      style={{ width: props.width, height: props.height, minHeight: 10 }}
      src={horseAvatar}
      alt="horse"
    />
  );
};

export const ClientAvatar = (props) => {
  return (
    <img
      style={{ width: props.width, height: props.height, minHeight: 10 }}
      src={clientAvatar}
      alt="client"
    />
  );
};

export const ClientAvatarLg = (props) => {
  return (
    <img style={{ width: 70, height: 70 }} src={clientAvatar} alt="client" />
  );
};

export const StaffAvatar = (props) => {
  return (
    <img
      style={{ width: props.width, height: props.height, color: props.color }}
      src={staffAvatar}
      alt="staff"
    />
  );
};

export const LocationAvatar = () => {
  return <img src={locationAvatar} alt="location" />;
};

export const HorseGreen = () => {
  return <img src={horseGreenBig} alt="greenhorse" />;
};

export const HorseSleep = () => {
  return <img src={horseSleep} alt="sleepinghorse" />;
};
